import { i18n } from '@lingui/core';
import { t } from '@lingui/macro';
import _ from 'lodash';
import {
    AGENT_STATUS_DISABLED,
    AGENT_STATUS_ENABLING,
    AGENT_STATUS_RESTART,
    AGENT_STATUS_UPDATE,
} from './AgentConstants';
import { buildActionParams, usePostBulkActionHandler } from './AgentListHelper';
import { useBulkActionWrapper, useFormSaveService } from '../../../services/FormSaveService';

export const updateMenuOption = {
    key: 'update',
    text: i18n._(t`Update`),
    updateObject: { status: AGENT_STATUS_UPDATE },
    successMessage: i18n._(t`Updating`),
};
export const enableMenuOption = {
    key: 'enable',
    text: i18n._(t`Enable`),
    updateObject: { status: AGENT_STATUS_ENABLING },
    successMessage: i18n._(t`Enabling`),
};
export const disableMenuOption = {
    key: 'disable',
    text: i18n._(t`Disable`),
    updateObject: { status: AGENT_STATUS_DISABLED },
    successMessage: i18n._(t`Disabling`),
};
export const restartMenuOption = {
    key: 'restart',
    text: i18n._(t`Restart`),
    updateObject: { status: AGENT_STATUS_RESTART },
    successMessage: i18n._(t`Restarting`),
};

export function useHandleAction(dataSource) {
    const postBulkActionHandler = usePostBulkActionHandler();
    const { bulkActionWrapper } = useBulkActionWrapper();
    const formSaveService = useFormSaveService();

    const handleActionClick = (menuOption, tableState, tableSelection, refresherFunc) => {
        return bulkActionWrapper({
            bulkActionFunction: () =>
                formSaveService.bulkActionSelection(
                    `${dataSource.crudUrl}/updateSelection`,
                    buildActionParams(dataSource, tableState),
                    tableSelection,
                    { updateObject: menuOption.updateObject },
                    _.partial(postBulkActionHandler, menuOption.updateObject)
                ),
            postBulkActionHandler: (response) => {
                refresherFunc();
                return response;
            },
            refresherFunc,
        })();
    };

    return handleActionClick;
}
